import I18N from '@leverege/i18n';
import Util from "./Util.js";
const {
  t,
  tIcon
} = I18N.ns('molten.screens.group.ScanQR');
export default {
  layout: {
    sort: 'bbbb'
  },
  handles: context => {
    return Util.getScanAttrs(context)?.length > 0;
  },
  appearance: ({
    context
  }) => {
    const scanType = Util.getScannableType(context);
    return {
      name: t('name'),
      icon: scanType === 'qr' ? tIcon('qrIcon', 'fa fa-fw fa-qrcode') : tIcon('barcodeIcon', 'fa fa-fw fa-barcode')
    };
  }
};